import React, { useEffect, useState } from "react";

import Visits from "@/components/Visits/Visits";
import { useHistory, useParams, useLocation } from "react-router-dom";
import Conversations from "@/components/Chat/Conversations";

import VisitDetails from "@/components/Visits/VisitDetails";
import VehicleVisits from "@/components/VehicleVisits/VehicleVisits";
import { Routes } from "@/routes";
import VehicleDetails from "@/components/VehicleDetails/VehicleDetails";
import Search from "@/components/Search/Search";

const HomePage = props => {
  const history = useHistory();
  const { chatId, placeId } = useParams();
  const { pathname } = useLocation();
  const [searchShow, setSearchShow] = useState(false);

  const [showVehicleVisits, setShowVehicleVisits] = useState(false);
  const [showVehicleDetails, setShowVehicleDetails] = useState(false);
  const [chatShow, setChatShow] = useState(false);

  const toggleSearch = () => {
    setSearchShow(!searchShow);
    if (searchShow) {
      history.push(Routes.Home.path);
    }
  }
  const toggleChat = () => {
    setChatShow(!chatShow)
    if (chatShow) {
      history.push(Routes.Home.path);
    }
  }

  const toggleShowVehicleVisits = () => {
    setShowVehicleVisits(!showVehicleVisits)
    if (showVehicleVisits) {
      history.push(Routes.Home.path);
    }
  }

  const [placeShow, setPlaceShow] = useState(false);
  const togglePlace = () => {
    setPlaceShow(!placeShow)
    if (placeShow) {
      history.push(Routes.Home.path);
    }
  }
  useEffect(() => {
    if (placeId) {
      togglePlace();
    } else {
      setPlaceShow(false)
    }
  }, [placeId])


  useEffect(() => {

    if (pathname === Routes.VehicleVisits.path) {
      setShowVehicleVisits(true);
    }
    if (pathname.includes(Routes.VehicleDetails.clean)) {
      setShowVehicleDetails(true);
    }
    if (pathname === Routes.Search.path) {
      setSearchShow(true);
    }

  }, [pathname])

  return (<>
    {showVehicleDetails && <VehicleDetails show={showVehicleDetails} toggle={() => {
      setShowVehicleDetails(false)
      history.push(Routes.Home.path);
    }} />}
    {chatShow && <Conversations chatId={chatId} toggle={toggleChat} show={chatShow} />}
    {searchShow && <Search toggle={toggleSearch} show={searchShow} />}
    {placeShow && <VisitDetails model={{ id: placeId }} toggle={togglePlace} show={placeShow} />}
    {showVehicleVisits && <VehicleVisits toggle={toggleShowVehicleVisits} show={showVehicleVisits} />}
    {/* THE GENERAL MAP WITH ALL THE FUNCTIONALITIES */}
    <Visits />
  </>)
}

export default HomePage
